import React, { useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import { schedulingApi } from "./schedulingApi";

export default function AttendanceModal({
  show,
  onHide,
  scheduledId,
  students,
  studentsLoading = false,
  onSaved,
}) {
  const [attendance, setAttendance] = useState({});
  const [saving, setSaving] = useState(false);

  const registered = students.filter((s) => s.status === "registered");

  const handleChange = (enquiryId, status) => {
    setAttendance((prev) => ({ ...prev, [enquiryId]: status }));
  };

  const enquiryKey = (s) => s.enquiry_id ?? s.enquiry?.id;

  const handleSubmit = async () => {
    if (!scheduledId) return;
    const list = registered.map((s) => {
      const eid = enquiryKey(s);
      return {
        enquiry_id: eid,
        status: attendance[eid] ?? "present",
      };
    });
    setSaving(true);
    try {
      const data = await schedulingApi.setAttendance(scheduledId, list);
      if (data?.error) {
        toast.error(data.error);
        return;
      }
      toast.success("Attendance saved.");
      onSaved?.();
    } catch (e) {
      toast.error(e?.message || "Failed to save attendance");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Mark Attendance</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {studentsLoading ? (
          <p className="text-muted small mb-0">Loading roster…</p>
        ) : null}
        <Table size="sm" bordered>
          <thead>
            <tr>
              <th>Student</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {!studentsLoading && registered.length === 0 ? (
              <tr>
                <td colSpan={2} className="text-muted">
                  No registered students for this session
                </td>
              </tr>
            ) : null}
            {!studentsLoading &&
              registered.map((s) => {
                const eid = enquiryKey(s);
                return (
                  <tr key={s.id ?? eid}>
                    <td>
                      {s.enquiry?.first_name} {s.enquiry?.last_name}
                    </td>
                    <td>
                      <Form.Select
                        size="sm"
                        value={attendance[eid] ?? "present"}
                        onChange={(e) => handleChange(eid, e.target.value)}
                      >
                        <option value="present">Present</option>
                        <option value="absent">Absent</option>
                        <option value="late">Late</option>
                      </Form.Select>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={saving || studentsLoading || registered.length === 0}
        >
          {saving ? "Saving…" : "Save Attendance"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
